if (!customElements.get('cart-drawer-extras')) {
  customElements.define(
    'cart-drawer-extras',
    class CartDrawerExtras extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.documentBlock = this.querySelector('[data-cart-document-type]');
        this.giftBlock = this.querySelector('[data-cart-gift]');
        this.validationAttempted = false;

        if (!this.form) return;

        this.addEventListener('input', this.handleInput.bind(this));
        this.addEventListener('change', this.handleChange.bind(this));
        this.form.addEventListener('submit', this.handleSubmit.bind(this));

        this.syncGiftValue();
        this.updateDocumentState();
      }

      handleInput(event) {
        if (event.target.matches('[data-invoice-field="rut"]')) {
          event.target.value = this.formatRut(event.target.value);
        }

        if (event.target.matches('[data-invoice-field]')) {
          this.updateDocumentState();
        }
      }

      handleChange(event) {
        if (event.target.matches('[data-document-selector]')) {
          if (event.target.value === 'boleta') {
            this.clearInvoiceFields();
          }

          this.validationAttempted = false;
          this.updateDocumentState();
          this.saveAttributes();
        }

        if (event.target.matches('[data-invoice-field]')) {
          this.updateDocumentState();
          this.saveAttributes();
        }

        if (event.target.matches('[data-cart-gift-checkbox]')) {
          this.syncGiftValue();
          this.saveAttributes();
        }
      }

      handleSubmit(event) {
        if (!this.invoiceIsSelected() || this.invoiceIsComplete()) return;

        event.preventDefault();
        this.validationAttempted = true;
        this.updateDocumentState();

        const firstInvalidField = this.querySelector('[data-invoice-field].is-invalid');
        if (firstInvalidField) firstInvalidField.focus();
      }

      invoiceIsSelected() {
        return this.querySelector('[data-document-selector][value="factura"]:checked') !== null;
      }

      invoiceIsComplete() {
        if (!this.documentBlock || !this.invoiceIsSelected()) return true;

        const rutField = this.querySelector('[data-invoice-field="rut"]');
        const businessNameField = this.querySelector('[data-invoice-field="business-name"]');
        const businessActivityField = this.querySelector('[data-invoice-field="business-activity"]');

        return (
          this.rutIsValid(rutField?.value || '') &&
          businessNameField?.value.trim() !== '' &&
          businessActivityField?.value.trim() !== ''
        );
      }

      updateDocumentState() {
        if (!this.documentBlock) return;

        const invoiceSelected = this.invoiceIsSelected();
        const invoiceFields = this.querySelector('[data-invoice-fields]');
        const invoiceIncomplete = invoiceSelected && !this.invoiceIsComplete();

        if (invoiceFields) invoiceFields.hidden = !invoiceSelected;

        this.form.classList.toggle('cart-drawer__footer--invoice-incomplete', invoiceIncomplete);

        const checkoutButton = this.form.querySelector('button[name="checkout"]');
        if (checkoutButton) {
          checkoutButton.setAttribute('aria-disabled', invoiceIncomplete ? 'true' : 'false');
        }

        this.querySelectorAll('[data-invoice-field]').forEach((field) => {
          let fieldIsValid = field.value.trim() !== '';

          if (field.matches('[data-invoice-field="rut"]')) {
            fieldIsValid = this.rutIsValid(field.value);
          }

          const showError = invoiceSelected && this.validationAttempted && !fieldIsValid;
          field.classList.toggle('is-invalid', showError);
          field.setAttribute('aria-invalid', showError ? 'true' : 'false');
        });
      }

      clearInvoiceFields() {
        this.querySelectorAll('[data-invoice-field]').forEach((field) => {
          field.value = '';
          field.classList.remove('is-invalid');
          field.setAttribute('aria-invalid', 'false');
        });
      }

      syncGiftValue() {
        if (!this.giftBlock) return;

        const checkbox = this.querySelector('[data-cart-gift-checkbox]');
        const valueInput = this.querySelector('[data-cart-gift-value]');

        if (checkbox && valueInput) {
          valueInput.value = checkbox.checked ? 'Es un regalo' : 'N/A';
        }
      }

      collectAttributes() {
        const attributes = {};

        this.querySelectorAll('[name^="attributes["]').forEach((input) => {
          if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;

          const attributeName = input.name.match(/^attributes\[(.+)\]$/)?.[1];
          if (attributeName) attributes[attributeName] = input.value;
        });

        return attributes;
      }

      saveAttributes() {
        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: this.collectAttributes() }),
          keepalive: true,
        });
      }

      formatRut(value) {
        const cleanValue = value.toUpperCase().replace(/[^0-9K]/g, '');

        if (cleanValue.length < 2) return cleanValue;

        return `${cleanValue.slice(0, -1)}-${cleanValue.slice(-1)}`;
      }

      rutIsValid(value) {
        const cleanValue = value.toUpperCase().replace(/[^0-9K]/g, '');
        const body = cleanValue.slice(0, -1);
        const verifier = cleanValue.slice(-1);

        if (body.length < 7 || !/^\d+$/.test(body)) return false;

        let sum = 0;
        let multiplier = 2;

        for (let index = body.length - 1; index >= 0; index -= 1) {
          sum += Number(body[index]) * multiplier;
          multiplier = multiplier === 7 ? 2 : multiplier + 1;
        }

        const result = 11 - (sum % 11);
        const expectedVerifier = result === 11 ? '0' : result === 10 ? 'K' : String(result);

        return verifier === expectedVerifier;
      }
    }
  );
}
